import * as $ from "jquery";
import { $body } from '../Core/Body';
import OSMap from "./OpenStreetMaps";
import "selectric/src/jquery.selectric";
import * as select2 from "select2";

export const DepartmentsModule = (() => {
	// @ts-ignore - HACK: types mismatch the module resolution. We need to actually init select2 this way in order to be able to call $().select2()
	select2();

	// language=JQuery-CSS
	const Selector = {
		MAP: {
			CONTAINER: '#department_map',
			SVG      : '#svg_poland_map'
		},
		REGION: '#svg_poland_map.department_page .svg_poland_map_region',
	};

	const JQMapSelector = $(Selector.MAP.CONTAINER);
	// const JSMapSelector = document.querySelector(Selector.MAP.CONTAINER);
	
	if (JQMapSelector.length) {
		const lon: number = JQMapSelector.data('lng');
		const lat: number = JQMapSelector.data('lat');
		const id : string = JQMapSelector.attr('id');

		// OSMaps.init(lng, lat, 18);
		const Map = new OSMap();
		Map.init(JQMapSelector.attr('id'), lon, lat, 18);
		Map.addMarker('https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png');
	}
	function showDepsInRegionOnly(e) {
		e.preventDefault();
		const $this = $(this);
		let url     = $this.parent().attr('href');
		if (url) {
			window.location.href = url;
			$this.addClass('active');
		}
	}

	$(".js-example-responsive").select2({
		width: 'resolve' // need to override the changed default
	});
	
	$body.on('click', Selector.REGION, showDepsInRegionOnly);

})();
import * as $ from "jquery";
import { $body } from '../Core/Body';
import OSMap from "./OpenStreetMaps";
import "selectric/src/jquery.selectric";
import * as select2 from "select2";

export const DepartmentsModule = (() => {
	// @ts-ignore - HACK: types mismatch the module resolution. We need to actually init select2 this way in order to be able to call $().select2()
	select2();

	// language=JQuery-CSS
	const Selector = {
		MAP: {
			CONTAINER: '#department_map',
			SVG      : '#svg_poland_map'
		},
		REGION: '#svg_poland_map.department_page .svg_poland_map_region',
	};

	const JQMapSelector = $(Selector.MAP.CONTAINER);
	// const JSMapSelector = document.querySelector(Selector.MAP.CONTAINER);
	
	if (JQMapSelector.length) {
		const lon: number = JQMapSelector.data('lng');
		const lat: number = JQMapSelector.data('lat');
		const id : string = JQMapSelector.attr('id');

		// OSMaps.init(lng, lat, 18);
		const Map = new OSMap();
		Map.init(JQMapSelector.attr('id'), lon, lat, 18);
		Map.addMarker('https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png');
	}
	function showDepsInRegionOnly(e) {
		e.preventDefault();
		const $this = $(this);
		let url     = $this.parent().attr('href');
		if (url) {
			window.location.href = url;
			$this.addClass('active');
		}
	}

	$(".js-example-responsive").select2({
		width: 'resolve' // need to override the changed default
	});
	
	$body.on('click', Selector.REGION, showDepsInRegionOnly);

})();
